import React,{Fragment} from 'react';
import PageWrapper from "../../components/PageWrapper";
import { useProductDetail } from '../../queries/productDetail';
import ProductDetail from "./ProductDetail";
import { useParams } from 'react-router-dom';
import InfinitProgressBar from '../../components/InfiniteProgressBar';

const ProductsDetails = () => {

    const params = useParams();
    const productInfo = useProductDetail(params.id);
    if (productInfo.error) return <div>error!</div>
    if (productInfo.loading) return <InfinitProgressBar />
    if (!productInfo.data) {
        return;
    }
    return (
        <Fragment>
            <PageWrapper classes={'product-details-wrapper sm-top'}>
                <div className="col-12">
                    <ProductDetail res={productInfo.data}/>
                    {/* <SkillsExperience teamMember={teamMember}/> */}
                    {/* <Education teamMember={teamMember}/> */}
                </div>
            </PageWrapper>
        </Fragment>
    );
};

export default ProductsDetails;